
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, ItemViewModel, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * ItemLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<ItemViewModel[]>> {
        return this.$apiService.sendAuth("IItemLookupService/Lookup", pCriteria);
    }
}
